import { render } from "./RedonyPage.vue?vue&type=template&id=4dc9794c&scoped=true"
import script from "./RedonyPage.vue?vue&type=script&lang=js"
export * from "./RedonyPage.vue?vue&type=script&lang=js"

import "./RedonyPage.vue?vue&type=style&index=0&id=4dc9794c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc9794c"]])

export default __exports__